import PropTypes from "prop-types";

import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";

AuthRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

function AuthRoute({ component: Component, ...rest }) {
  const history = useHistory();

  const [next, setNext] = useState(false);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user === null) {
      history.replace("/auth");
      return;
    }

    // let hasRole = user.role.namekey === "ADMIN";
    // if (!hasRole) {
    //   history.push("/auth");
    // }
    setNext(true);
  }, [history, user]);

  return (
    <Route
      {...rest}
      render={() => {
        return next ? <Component /> : <></>;
      }}
    ></Route>
  );
}

export default AuthRoute;
